module.exports = __webpack_public_path__ + "img/spiritofivory.ef077db5.png";